import {combineLatest, merge} from 'rxjs';
import {map, scan} from 'rxjs/operators';
import {currencies$} from '@/config';
import {wsLogout$} from '@/user/auth-ws';
import {woMsg$} from '@/raw/wo';
import type {ws, ReduceAction, CurrencyEntity} from '@/types';

type WoMsg = ws.WOMsg;
type WalletRaw = ws.WalletRaw;

type Cache = Map<string, WalletRaw>;
type Action = ReduceAction<Cache>;

const init$ = currencies$.pipe(
  map((currencies): Action => {
    return (cache: Cache) => {
      currencies.forEach((item) => (cache.has(item.currency) ? cache : cache.set(item.currency, initWallet(item))));
      return cache;
    };
  })
);

const reset$ = wsLogout$.pipe(
  map(
    (): Action => (cache: Cache) => {
      cache.clear();
      return cache;
    }
  )
);

const walletsData$ = woMsg$.pipe(map((data: WoMsg) => data.wallets));

const action$ = combineLatest([walletsData$, currencies$]).pipe(
  map(([wallets, currencyEntities]: [WalletRaw[], CurrencyEntity[]]): Action => {
    const currencies = currencyEntities.map((o) => o.currency);
    return (cache: Cache) => {
      wallets.filter((o) => currencies.includes(o.currency)).forEach((wallet) => cache.set(wallet.currency, wallet));
      return cache;
    };
  })
);

export const spotWalletsCache$ = merge<Action[]>(init$, action$, reset$).pipe(
  scan((p: Cache, c: Action) => c(p), new Map<string, WalletRaw>())
);

function initWallet({currency, displayCurrency}) {
  return {
    balanceEv: 0,
    currency,
    displayCurrency,
    lastUpdateTimeNs: Date.now(),
    lockedTradingBalanceEv: 0,
    lockedWithdrawEv: 0,
    userID: 0,
  };
}
